import { createTemplateFactory } from "@ember/template-factory";
function RouteTemplate(Component) {
  return createTemplateFactory(
  /*
    <Component @model={{@model}} @controller={{this}} />
  */
  {
    "id": "YvO+FIoy",
    "block": "[[[8,[32,0],null,[[\"@model\",\"@controller\"],[[30,1],[30,0]]],null]],[\"@model\"],false,[]]",
    "moduleName": "/var/www/discourse/node_modules/ember-route-template/dist/index.js",
    "scope": () => [Component],
    "isStrictMode": true
  });
}
export { RouteTemplate as default };